/*
 *   File : file-viewer.js
 *   Author URI : https://evoqins.com
 *   Description : UI element to view uploaded files.
 *   Integrations : null
 *   Version : v1.1
 */
import { useEffect, useState } from "react";

import { Icon } from "../Icon";
import { CustomLoader } from "../Other";

import style from "../../Styles/Components/file-viewer.module.scss";


export default function FileViewer(props) {

    // const [fileType, setFileType] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        var my_modal = document.getElementById("file-viewer");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);

    const handleLoad = () => {
        setIsLoading(false);
        console.log('load complete')
    };

    const handleError = () => {
        setIsLoading(false); // Set loading state to false if there's an error loading the PDF
        console.error("Error loading PDF");
    };


    return (

        // fileType 2 is when on upload there is only image format upload not pdf
        props.fileType === 2 ?
            <div className={`modal fade ${style.e_file_viewer}`}
                id="file-viewer"
                tabIndex="-1"
                aria-labelledby="file-viewer"
                aria-hidden="true"
                data-bs-backdrop="true" >
                <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                    <div className={`modal-content p-4 ${style.e_content} `}>
                        <div className="mb-4 d-flex align-items-center justify-content-between">
                            <p className="color-black e-poppins-medium e-font-16 line-height-16px mb-0">Preview your document</p>
                            <Icon icon="close"
                                size={24}
                                data-bs-dismiss="modal"
                                className="cursor-pointer e-modal-close-btn" />
                        </div>
                        <div className="mx-5 border-radius-16px border-all border-bright-gray">
                            <img src={props.data}
                                alt="File preview"
                                className="object-fit-contain w-100 h-100 border-radius-16px" />
                            {
                                props.showLocation && props.location &&
                                <p className="color-black e-poppins-medium e-font-12 ps-3 mb-2">{props.location}</p>
                            }

                        </div>

                    </div>
                </div>
            </div>
            :
            <div className={`modal fade ${style.e_file_viewer}`}
                id="file-viewer"
                tabIndex="-1"
                aria-labelledby="file-viewer"
                aria-hidden="true"
                data-bs-backdrop="true" >
                <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                    <div className={`modal-content bg-white text-center d-flex align-items-center padding-32px-all ${style.e_content} `}>
                        <Icon icon="close"
                            size={24}
                            id="close-modal"
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal" />
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex justify-content-center align-items-middle h-100">

                                    {
                                        props.data?.type === 2 ?
                                            <img src={props.data?.url} className="w-90" />
                                            :
                                            <>

                                                {isLoading === true &&
                                                    <div className="position-absolute w-100 h-75">
                                                        <CustomLoader />
                                                    </div>
                                                }

                                                <iframe
                                                    title="PDF Viewer"
                                                    src={`https://docs.google.com/viewer?url=${encodeURIComponent(props.data?.url)}&embedded=true`}
                                                    style={{ width: '500px', height: '500px', border: 'none' }}
                                                    onLoad={handleLoad}
                                                    onError={handleError}
                                                />
                                            </>

                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
} 